// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__ctBwl","closeButton":"Modal_closeButton__lCf4h"};